export default __webpack_public_path__ + "static/media/eyes-opened-icon.ba7760e1.svg";